import { Group, SegmentedControl, Stack, Text } from '@mantine/core';
import { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Content } from '@/core/components';

interface TravelChartPanelProps {
  title: string;
  caption: string;
  chart: ReactNode;
  table: ReactNode;
}

type ChartView = 'chart' | 'table';

export function TravelChartPanel({ title, caption, chart, table }: TravelChartPanelProps) {
  const { t } = useTranslation();
  const [view, setView] = useState<ChartView>('chart');

  return (
    <Content
      bg="white"
      role="group"
      aria-label={title}
    >
      <Group
        justify="space-between"
        align="start"
        wrap="nowrap"
      >
        <Stack gap={2}>
          <Text fw={500}>{title}</Text>
          <Text
            size="xs"
            c="dimmed"
          >
            {caption}
          </Text>
        </Stack>
        <SegmentedControl
          size="xs"
          value={view}
          onChange={value => setView(value as ChartView)}
          data={[
            { value: 'chart', label: t('travel.registry.aggregates.yearly.chart') },
            { value: 'table', label: t('travel.registry.aggregates.yearly.table') },
          ]}
        />
      </Group>
      {view === 'chart' ? chart : table}
    </Content>
  );
}
